module.exports = __webpack_public_path__ + "img/EV.a69e1d9a.png";